<template>
  <j-modal
    :title="title"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel">
    <yoy-form ref="realForm" @ok="submitCallback" :disabled="disableSubmit" :record="record"/>

  </j-modal>
</template>

<script>

  import YoyForm from './YoyForm'

  export default {
    name: 'YoyModal',
    components: {
      YoyForm
    },
    data() {
      return {
        title:'',
        width:800,
        visible: false,
        disableSubmit: false,
        record:{}
      }
    },
    methods:{
      show (record) {
        this.record = record
        this.visible=true
        // this.$nextTick(()=>{
        //   this.$refs.realForm.add();
        // })
      },
      edit (record) {
        this.visible=true
        this.$nextTick(()=>{
          this.$refs.realForm.edit(record);
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        this.$refs.realForm.submitForm();
      },
      submitCallback(){
        this.$emit('ok');
        this.visible = false;
      },
      handleCancel () {
        this.close()
      }
    }
  }
</script>

<style scoped>
</style>